import { lazyLoad } from 'utils/loadable';
import LoadingSpinner from 'app/components/Loading/LoadingSpinner';

export const QuotesSearch = lazyLoad(
    () => import('./index'),
    module => module.QuotesSearch,
    { fallback: <LoadingSpinner /> },
);
